module.exports = __webpack_public_path__ + "img/nextbutton.5362325a.svg";